import { Component, EventEmitter, Input, Output } from '@angular/core';
import { validationRules } from '../custom-datatable/validation';

@Component({
  selector: 'app-custom-grid-table',
  templateUrl: './custom-grid-table.component.html',
  styleUrls: ['./custom-grid-table.component.scss']
})
export class CustomGridTableComponent {
  @Input() tables: any[] = [];
  @Input() isEditMode = false;
  @Output() onDataSave = new EventEmitter<any>();
  @Input() onCellRender: Function;
  columnsPerRow=2;
  newRow: any = {};
  errors: any = {};
  Math = Math;
  array = Array;
  isSettingsOpen: boolean = false;
  schemaName: any;
  columnsCopy: any;

  saveTableData(updatedData: any, tableTitle: string) {
      this.onDataSave.emit({ tableTitle, updatedData });
  }


  /**
   * Validates a single field based on its type.
   * @param field - Field name in newRow
   * @param type - Type of field (text, number, date, currency, etc.)
   */
  validateField(columns:any,field: string, type: string, index?: any, data?: any) {
    const column = columns.find(col => col.field === field);
    const value = index !== undefined ? data[field] : this.newRow[field];

    let errorMessage = null;

    if (column && column.validations) {
      errorMessage = this.applyValidations(value, column.name, column.validations);
    }
    if(!errorMessage && column.type==='number' && value<0){
      errorMessage = `${column.name} must be a positive number.`
    }

    if (index !== undefined) {
      this.errors[index] = { ...(this.errors[index] || {}), [field]: errorMessage };
    } else {
      this.errors[field] = errorMessage;
    }

  }


  applyValidations(value: any, fieldTitle: string, validations: string[]) {
    for (const rule of validations) {
      const message = validationRules[rule](value, fieldTitle);
      if (message !== true) {
        return message;
      }
    }
    return null;

  };

  formatCurrency(value: number, locale: string = 'en-US', currency: string = 'USD'): string {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value && !isNaN(value) ? value : 0);
  }

  formatNumber(value: number, locale: string = 'en-US'): string {
    return new Intl.NumberFormat(locale).format(value);
  }

  


  renderCell(data) {
    return this.onCellRender(data);
  }

  
  openSettings(columns,schemaName) {
    this.isSettingsOpen = true;
    this.schemaName=schemaName;
    if (columns && Array.isArray(columns)) {
      this.columnsCopy = JSON.parse(JSON.stringify(columns));
    }
  }

  applySettings() {
    let data = { columns: this.columnsCopy }
    this.onDataSave.emit({ type: 'tableViewUpdate', data: data, schemaName: this.schemaName });
    this.isSettingsOpen = false;
  }

}
